import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import { Message } from "./messsage";

export function MessagesList() {
  const chatMessages = useVidyoStore((s) => s.chat.messages);

  return (
    <div className="space-y-4 p-4">
      {chatMessages.map((message) => (
        <Message key={message.timestamp.toISOString()} message={message} />
      ))}
    </div>
  );
}
